import { ENDPOINT_SUBSCRIPTIONS } from '../config'
import type { BillingPortalResponse } from '../types'
import AuthAxios from '@/lib/api/axios/AuthAxios'

/**
 * Create a Stripe Billing Portal Session
 * Allows users to manage their subscription, update payment methods, view invoices, etc.
 * @returns Billing Portal Session with URL to redirect to
 */
export async function createBillingPortalSession(): Promise<BillingPortalResponse> {
  const response = await AuthAxios.post<BillingPortalResponse>(
    `${ENDPOINT_SUBSCRIPTIONS}/create-billing-portal-session`
  )
  return response.data
}
